import { render, staticRenderFns } from "./Autorizar.html?vue&type=template&id=4eccf51c&scoped=true&"
import script from "./Autorizar.vue?vue&type=script&lang=js&"
export * from "./Autorizar.vue?vue&type=script&lang=js&"
import style0 from "./Autorizar.css?vue&type=style&index=0&id=4eccf51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eccf51c",
  null
  
)

export default component.exports